module.exports = "./img/2cb591382664a7b5360c23eb8cb75464.jpg";